
import { HttpClient, HttpResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable ,Inject} from '@angular/core';

import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class ServiceBase {
  constructor(public http: HttpClient) {
  }

  protected CommonGet2(url): Observable<HttpResponse<any>> {
    // this.httClient.get()
    return this.http.get<any>(url, { observe: 'response' });
  }


  ///TODO:
  protected CommonGetWithParams(url, params): Observable<any> {
    // this.httClient.get()

    let pa = new HttpParams();
    // HttpParams {
    //   private map;
    //   private encoder;
    //   private updates;
    //   private cloneFrom;
    //   constructor(options?: {
    //       fromString?: string;
    //       encoder?: HttpParameterCodec;
    //   });

    return this.http.get<any>(url, { params: params });

  }


  /**執行http Get */
  protected ComonGet(url): Observable<any> {


      return this.http.get(url);  
      
      
    }
 

  /**執行http Get */
  protected CommonPatch(url,body): Observable<any> {

 
      return this.http.get(url);
      
    
  }




  /**執行http post */
  protected CommonPost(url, criteria): Observable<any> {

    var headers = new HttpHeaders();

    headers = headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );

    var postData: string = this.transformRequest(criteria);

    return this.http.post(url, postData, { headers: headers });
  
  }


  /**執行http post */
  protected CommonPostRaw(url, data): Observable<any> {
    console.log(url,data);
    return this.http.post(url, data);

  }


  /**轉換json to x-www-form-urlencoded */
  transformRequest(obj) {
    var str = [];
    for (var p in obj) {
      var value: string;
      if (obj[p] == null) {
        value = "";
      } else {
        value = encodeURIComponent(obj[p])
      }
      str.push(encodeURIComponent(p) + "=" + value);
    } return str.join("&");
  }

  

}
